import { render, staticRenderFns } from "./RecordExchangeValidationView.vue?vue&type=template&id=d8657c72&"
import script from "./RecordExchangeValidationView.vue?vue&type=script&lang=js&"
export * from "./RecordExchangeValidationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports